import {CustomerDocumentType} from '../../interfaces/customer-documents/customer-document-type';
import {
  CustomerDocumentTypePermissionLevel
} from '../../enums/customer-documents/customer-document-type-permission-level.enum';
import {CdoIntervalUnit} from '../../enums/customer-documents/cdo-interval-unit.enum';
import {CdoIntervalMode} from '../../enums/customer-documents/cdo-interval-mode.enum';


export class CustomerDocumentTypeFactory {
  /**
   *
   * @param customerDocumentType
   */
  public static fromObject(customerDocumentType: any): CustomerDocumentType {
    return new class implements CustomerDocumentType {
      color: string = customerDocumentType.color;
      id: number= customerDocumentType.id;
      isConfirmationNeeded: boolean =
        customerDocumentType.is_confirmation_needed ?? customerDocumentType.isConfirmationNeeded;
      name: string= customerDocumentType.name;
      canModify: number = customerDocumentType.can_modify
        ?? customerDocumentType.canModify
        ?? CustomerDocumentTypePermissionLevel.Locked;
      serviceFacilityIds: number[] = customerDocumentType.service_facility_ids ?? customerDocumentType.serviceFacilityIds;
      // The legacy key keeps basic data objects that are still cached in Dexie
      // from falling back to 1 until the next sync
      requiredCount: number = customerDocumentType.required_count
        ?? customerDocumentType.requiredCount
        ?? customerDocumentType.interval
        ?? 1;
      intervalUnit: CdoIntervalUnit = customerDocumentType.interval_unit ?? customerDocumentType.intervalUnit ?? null;
      intervalMode: CdoIntervalMode = customerDocumentType.interval_mode
        ?? customerDocumentType.intervalMode
        ?? CdoIntervalMode.Calendar;
    };
  }

  /**
   *
   * @param customerDocumentTypes
   */
  public static fromArray(customerDocumentTypes: any[]): CustomerDocumentType[] {
    return customerDocumentTypes.map(_customerDocumentType => this.fromObject(_customerDocumentType));
  }
}